import React, { useCallback, useEffect, useState } from "react";
import { MdCheck, MdCancel } from "react-icons/md";
import { format } from "date-fns";
import TableColumn from "../../components/TableColumn/TableColumn";
import { ButtonActions } from "../../components/TableColumn/styles";
import AffiliateLayout from "../../components/AffiliateLayout/AffiliateLayout";
import api from "../../services/api";

// Affiliate (promoter) waitlist. Self-serve portal signups land here as
// 'pending' and stay dark (no live promo code, no attribution) until an admin
// approves them. Mirrors the DJ Requests approve/deny queue.
const AffiliateWaitlist = () => {
  const [rows, setRows] = useState([]);

  const fmt = (d) => {
    try {
      return d ? format(new Date(d), "MMM d, yyyy") : "-";
    } catch (_) {
      return "-";
    }
  };

  const load = useCallback(async () => {
    try {
      const { data } = await api.get(`/promoters/waitlist`);
      const list = Array.isArray(data) ? data : data?.data || [];

      // Defined inside load so it can re-call load after a review, without a
      // circular useCallback dependency.
      const review = async (id, status) => {
        const verb = status === "approved" ? "approve" : "deny";
        if (!window.confirm(`Are you sure you want to ${verb} this affiliate?`)) return;
        try {
          await api.put(`/promoters/${id}/status`, { status });
          await load();
        } catch (err) {
          console.error("[affiliate waitlist] review failed", err);
          alert("Could not update. Please try again.");
        }
      };

      setRows(
        list.map((p) => ({
          Name:
            p.name ||
            [p.user?.firstName, p.user?.lastName].filter(Boolean).join(" ") ||
            "-",
          Email: p.email || p.user?.email || "-",
          Phone: p.phone || p.user?.phone || "-",
          Code: p.promo_code || "-",
          Applied: fmt(p.created_at),
          "": (
            <div style={{ display: "flex", gap: 8 }}>
              <ButtonActions title="Approve" onClick={() => review(p._id, "approved")}>
                <MdCheck size={26} color="#4F30EA" />
              </ButtonActions>
              <ButtonActions title="Deny" onClick={() => review(p._id, "denied")}>
                <MdCancel size={26} color="red" />
              </ButtonActions>
            </div>
          ),
          id: p._id,
        }))
      );
    } catch (err) {
      console.error("[affiliate waitlist] load failed", err);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const columns = ["Name", "Email", "Phone", "Code", "Applied", ""];

  return (
    <AffiliateLayout>
      <TableColumn
        title="Affiliate Waitlist"
        hasHeader={true}
        columns={columns}
        data={rows}
        hasSearch={true}
        hasExport={false}
        totalPages={1}
        currentPage={1}
        onPageChange={() => {}}
        records={9999}
      />
    </AffiliateLayout>
  );
};

export default AffiliateWaitlist;
